import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updatePlanAndRateStatusByFilter } from '../../../api/plan-and-rate-override-rules-api'
import type { PlanAndRateOverrideRuleStatus } from '../enums/plan-and-rate-override-rule.enum'
import type {
  UpdatePlanAndRateStatusByFilterQueryDto,
  UpdatePlanAndRateStatusByFilterResponseDto,
} from '../../../api/dto/plan-and-rate-override-rules.dto'
import { PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanAndRateOverride/hooks/useGetPlanAndRateOverrideRules'

interface Variables {
  query: UpdatePlanAndRateStatusByFilterQueryDto
  targetStatus: PlanAndRateOverrideRuleStatus
}

export function useUpdatePlanAndRateStatusByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    UpdatePlanAndRateStatusByFilterResponseDto,
    unknown,
    Variables
  >({
    mutationFn: ({ query, targetStatus }) =>
      updatePlanAndRateStatusByFilter(query, { status: targetStatus }),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [PLAN_AND_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
